<template>

  <v-sidebar v-model:visible="display"  :header="$t('profile')" position="right" :showCloseIcon="true"
             style = "width: 21.5rem;"
           :baseZIndex="1000" class="layout-config p-sidebar-sm p-0">
    <div class="layout-config-panel flex flex-column">
<!--      <div class="px-3">-->
<!--        <h5>{{$t('settings')}}</h5>-->
<!--      </div>-->
      <hr class="mb-0 mt-0" />


      <div class="layout-config-options p-3">
        <div class="mb-4"><b>{{$t('organization')}}</b><br class="mb-1"/>
          {{ $t('nao') }}
        </div>

        <div class="mb-4"><b>{{ $t('photo_profile') }}</b><br class="mb-1"/>
        <div class="flex flex-wrap align-items-center justify-content-center">
          <div class="flex align-items-center justify-content-center mt-4 mb-4">
<!--            <ProgressSpinner aria-label="Loading" ></ProgressSpinner>-->
            <Avatar class="justify-content-center" :image="user.avatar_src" style="height: 7rem; width: 7rem;" shape="circle"></Avatar>

            <div class="avatar_hover">
              <button @click="launchFilePicker()" class="avatar_button">
                <svg width="18" height="18" viewBox="0 0 24 24" focusable="false" style="    color: #444746;" class="uarSJe NMm5M"><path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h16v12z"></path><path d="M12 9c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"></path></svg>
              </button>
            </div>
            <input type="file"
                   ref="file"
                   accept="image/jpeg, image/png, image/svg, image/gif, image/jpg"
                   :name="uploadFieldName"
                   @change="onFileChange($event.target.files)"
                   style="display:none">
          </div>
        </div>
        </div>
        <div class="mb-4">
        <b>{{ $t('user') }}</b><br class="mb-1"/>
        {{ user.full_name }}
        </div>
        <div v-if="user.uid" class="mb-4">
          <v-overlayPanel :breakpoints="{'60px': '75vw', '64px': '100vw'}" :style="{width: '450px'}"  ref="op">
            {{ $t('id_info', {'uid' : user.uid, 'year': user.uid.substring(0, 4), 'role': user.uid.substring(5, 4), 'id': user.uid.substring(5, 9)}) }}
          </v-overlayPanel>
        <b>{{ $t('user id') }}</b>
<!--          <span  @mouseover="show"-->
<!--                                                @mouseleave="hide"-->
<!--                                                class="p-overlay-badge">-->
<!--            <i style="color: blue" class="pi pi-info-circle"></i>-->
<!--          </span>-->
          &nbsp;
          <i v-if="isDesktop" class="pi pi-info-circle" v-tooltip="{ value: $t('id_info_login'), class: 'w-12rem', showOnFocus: true }" />

          <br class="mb-1"/>
          {{ user.uid }} &nbsp;


        </div>
        <div class="mb-4">
        <b>{{ $t('email') }}</b><br class="mb-1"/>
          {{ user.email }}
        </div>

        <div class="flex cursor-pointer">
          <div class="flex flex-column">
            <div @click="logout" style="color: var(--primary-color)" >
              {{ $t('logout') }} <i class="pi pi-arrow-right fs-xsmall"></i>
            </div>
          </div>
        </div>
<!--        <h5>{{$t('advises')}}</h5>-->
<!--      <hr class="mb-0" />-->

<!--        <div style="height: 38rem !important;" class="relative align-items-stretch flex flex-column align-content-center justify-content-center">-->
<!--          <div class="flex align-self-center align-items-center justify-content-center mb-6">-->
<!--            <img  src="/layout/images/push.svg"  style="height: 10rem">-->
<!--          </div>-->
<!--          <div class="flex align-items-center justify-content-center text-center">-->
<!--            <span style="font-size: 1.2rem">-->
<!--              {{ $t('no_content') }}-->
<!--            </span>-->
<!--            <br/>-->
<!--          </div>-->
<!--        </div>-->
    </div>
    </div>
  </v-sidebar>

</template>

<script>
import store from "@/store";
import vSidebar from "@/primevue/sidebar/Sidebar.vue"
import vOverlayPanel from "@/primevue/overlaypanel/OverlayPanel.vue"
import {logout} from "@/authService";

export default {
  name: "UserSidebar",
  data() {
    return {
      display: false,
      loading: false,
      uploadFieldName: 'file',
      maxSize: 1024
    }
  },
  components: {
    vSidebar,
    vOverlayPanel
  },
  methods:{
    logout() {
      logout();
      // store.dispatch("logout").then(() => {
      //   window.location.reload();
      // });
    },
    show(event) {
      this.$refs.op.show(event);
    },
    hide(event) {
      this.$refs.op.hide(event);
    },
    openModal(){
      this.display = true
    },
    launchFilePicker(){
      this.$refs.file.click();
    },
    onFileChange(file) {
      const { maxSize } = this
      let imageFile = file[0]
      if (file.length>0) {
        let size = imageFile.size / maxSize / 1024
        if (!imageFile.type.match('image.*')) {
          this.$toast.add({severity:'error', summary: 'Error Message', detail: this.$t('Please choose image'), life: 3000});
        } else if (size>1) {
          this.$toast.add({severity:'error', summary: 'Error Message', detail: this.$t('file big 2MB'), life: 3000});
        } else {
          let formData = new FormData()
          formData.append('avatar', imageFile)
          this.sendData(formData)
        }
      }
    },
    sendData(formData){
      this.loading = true;
      store
        .dispatch("changeAvatar", formData)
        .then((res) => {
          console.log(res)
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          this.$toast.add({severity: 'error', summary: 'Error Message', detail: err.response.data.error, life: 30000});
        });
    }
  },
  mounted() {
    // if (store.state.user.token) {
    //   store.dispatch("getUser");
    // }
  },
  computed: {
    user() {
      return store.state.user.data
    },
    isDesktop() {
      return window.innerWidth > 991;
    },
  }
}
</script>

<style scoped>
.avatar_button{
  margin: 3px;
  background: none;
  border: 1px solid #c4c7c5;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  bottom: 0;
  box-shadow: none;
  right: 0;
  z-index: auto;
  color: #3c4043;
  height: 24px;
  outline: 0;
  padding: 0;
  position: absolute;
  width: 24px;
}
.avatar_hover{
  background: white;
  border-radius: 50%;
  bottom: -30px;
  height: 30px;
  position: relative;
  right: 30px;
  width: 30px;
}
</style>
